import { overseaTranslate } from 'services/api/overseaTranslate';
import { tolgee } from 'services/i18n/tolgee';
import { LRUMap } from 'lib/lruMap';

const lruMap = new LRUMap<string, string>(200 * 8);

/**
 * fork reportTask.ts from src/hooks/useTranslateReport/reportTask.ts
 * 需要改下实现
 */
type Req<T> = (body: T[]) => Promise<T[]>;
interface Task<T> {
  body: T;
  resolve: (result: T) => void;
}
interface Options<T> {
  request: Req<T>;
  delay?: number;
}

export class ReportTask<T> {
  private _taskQueue: Array<Task<T>>;
  private _timer: any;
  private _delay?: number;
  private _request: Req<T>;

  constructor(options: Options<T>) {
    this._taskQueue = [];
    this._request = options.request;
    this._delay = options.delay ?? 2000;
  }

  public run(task: { body: T; resolve: (result: T) => void }) {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._taskQueue.push(task);

    this._timer = setTimeout(() => {
      const runTask = this._taskQueue.splice(0);
      const params = runTask.reduce((prev, cur) => {
        if (Array.isArray(cur.body)) {
          return [...prev, ...cur.body];
        } else {
          return [...prev, cur.body];
        }
      }, [] as T[]);
      this._request(params).then((result) => {
        runTask.forEach((task, index) => {
          task.resolve(result[index]);
        });
      });
      clearTimeout(this._timer);
    }, this._delay);
  }
}

const task = new ReportTask<string>({
  request: (text) => {
    return overseaTranslate(text, tolgee.getLanguage() as General.Language, 'singleClass').catch(
      () => [],
    );
  },
  delay: 16 * 2, // 16为一帧的时间
});

export const getTranslate = (source: string) => {
  return new Promise<string>((resolve) => {
    const cache = lruMap.get(`${source}-${tolgee.getLanguage()}`);
    if (cache) {
      return resolve(cache);
    }
    const _resolve = (val: string) => {
      if (val) {
        lruMap.set(`${source}-${tolgee.getLanguage()}`, val);
        return resolve(val);
      } else {
        return resolve(source);
      }
    };
    task.run({
      body: source,
      resolve: _resolve,
    });
  });
};
